import React from 'react';
import PropTypes from 'prop-types';
import { InsertLinkToAnchorDialog } from '../../../content-edit-controls';

const InsertLinkToAnchorDialogWindow = ({ onSave, onCancel, params }) =>
{
  const {
    isEditMode,
    isLinkEditable,
    imageLink,
    link,
    title,
    tooltip
  } = params;

  const handleUnlink = () =>
  {
    onSave({ ...params, link: '' });
  };

  const handleSave = (payload) =>
  {
    const { anchorName, linkText, tooltip: anchorTooltip } = payload;

    const encodedAnchor = `#${encodeURIComponent(anchorName)}`;
    const anchorTitle = linkText || anchorName;

    const data = {
      ...params,
      tooltip: anchorTooltip,
      link: encodedAnchor,
      title: anchorTitle
    };

    onSave(data);
  };

  const decodedLink = decodeURIComponent(link);

  return (
    <InsertLinkToAnchorDialog
      isEditMode={isEditMode}
      isLinkEditable={isLinkEditable}
      isLinkHidden={!!imageLink}
      anchorName={decodedLink}
      linkText={title}
      tooltip={tooltip}
      previewImage={imageLink}
      onSave={handleSave}
      onCancel={onCancel}
      onUnlink={handleUnlink}
    />
  );
};

InsertLinkToAnchorDialogWindow.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  params: PropTypes.shape({}).isRequired
};

export default InsertLinkToAnchorDialogWindow;